import Nullstack from 'nullstack';
export default function IconCertificate({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-certificate",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "15",
    cy: "15",
    r: "3"
  }), "   ", Nullstack.element("path", {
    d: "M13 17.5v4.5l2 -1.5l2 1.5v-4.5"
  }), "   ", Nullstack.element("path", {
    d: "M10 19h-5a2 2 0 0 1 -2 -2v-10c0 -1.1 .9 -2 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -1 1.73"
  }), "   ", Nullstack.element("line", {
    x1: "6",
    y1: "9",
    x2: "18",
    y2: "9"
  }), "   ", Nullstack.element("line", {
    x1: "6",
    y1: "12",
    x2: "9",
    y2: "12"
  }), "   ", Nullstack.element("line", {
    x1: "6",
    y1: "15",
    x2: "8",
    y2: "15"
  }), " ");
}